import {Navigate, Outlet} from 'react-router-dom';
import { PRIVATE } from 'Shared/Routing/Application/Constants/PathsConstant';
import {useAuthContext} from 'Shared/Security/Domain/Contexts/authContext';

export default function PublicRoute() {
  const {isAuthenticated} = useAuthContext();

  if (isAuthenticated) {
    let targetPath = new URLSearchParams(window.location.search).get('targetPath');
    if (targetPath) {
      return <Navigate to={targetPath} />;
    }
    return <Navigate to={PRIVATE} />;
  }

  return (
    <>
      <Outlet />
    </>
  );
}
